"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FiltersController", {
    enumerable: true,
    get: function() {
        return FiltersController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _PagedResponse = require("~/helpers/PagedResponse");
const _filtersservice = require("~/services/filters.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let FiltersController = class FiltersController {
    async filterList(context, viewId, includeAllFilters) {
        return new _PagedResponse.PagedResponseImpl(await this.filtersService.filterList(context, {
            viewId,
            includeAllFilters: includeAllFilters === 'true'
        }));
    }
    async filterCreate(context, viewId, body, req) {
        const filter = await this.filtersService.filterCreate(context, {
            filter: body,
            viewId: viewId,
            user: req.user,
            req
        });
        return filter;
    }
    async hookFilterCreate(context, hookId, body, req) {
        const filter = await this.filtersService.hookFilterCreate(context, {
            filter: body,
            hookId,
            user: req.user,
            req
        });
        return filter;
    }
    async filterGet(context, filterId) {
        return await this.filtersService.filterGet(context, {
            filterId
        });
    }
    async filterChildrenList(context, filterParentId) {
        return new _PagedResponse.PagedResponseImpl(await this.filtersService.filterChildrenList(context, {
            filterId: filterParentId
        }));
    }
    async filterUpdate(context, filterId, body, req) {
        const filter = await this.filtersService.filterUpdate(context, {
            filterId: filterId,
            filter: body,
            user: req.user,
            req
        });
        return filter;
    }
    async filterDelete(context, filterId, req) {
        const filter = await this.filtersService.filterDelete(context, {
            req,
            filterId
        });
        return filter;
    }
    async hookFilterList(context, hookId) {
        return new _PagedResponse.PagedResponseImpl(await this.filtersService.hookFilterList(context, {
            hookId: hookId
        }));
    }
    constructor(filtersService){
        this.filtersService = filtersService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/views/:viewId/filters',
        '/api/v2/meta/views/:viewId/filters'
    ]),
    (0, _extractidsmiddleware.Acl)('filterList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Query)('includeAllFilters')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersController.prototype, "filterList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/views/:viewId/filters',
        '/api/v2/meta/views/:viewId/filters'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('filterCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.FilterReqType === "undefined" ? Object : _nocodbsdk.FilterReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersController.prototype, "filterCreate", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/hooks/:hookId/filters',
        '/api/v2/meta/hooks/:hookId/filters'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('hookFilterCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('hookId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.FilterReqType === "undefined" ? Object : _nocodbsdk.FilterReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersController.prototype, "hookFilterCreate", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/filters/:filterId',
        '/api/v2/meta/filters/:filterId'
    ]),
    (0, _extractidsmiddleware.Acl)('filterGet'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('filterId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersController.prototype, "filterGet", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/filters/:filterParentId/children',
        '/api/v2/meta/filters/:filterParentId/children'
    ]),
    (0, _extractidsmiddleware.Acl)('filterChildrenList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('filterParentId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersController.prototype, "filterChildrenList", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/filters/:filterId',
        '/api/v2/meta/filters/:filterId'
    ]),
    (0, _extractidsmiddleware.Acl)('filterUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('filterId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.FilterReqType === "undefined" ? Object : _nocodbsdk.FilterReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersController.prototype, "filterUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/filters/:filterId',
        '/api/v2/meta/filters/:filterId'
    ]),
    (0, _extractidsmiddleware.Acl)('filterDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('filterId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersController.prototype, "filterDelete", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/hooks/:hookId/filters',
        '/api/v2/meta/hooks/:hookId/filters'
    ]),
    (0, _extractidsmiddleware.Acl)('hookFilterList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('hookId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], FiltersController.prototype, "hookFilterList", null);
FiltersController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _filtersservice.FiltersService === "undefined" ? Object : _filtersservice.FiltersService
    ])
], FiltersController);
